export default async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error(err);
    alert('Failed to copy');
  }
}
